"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var _1 = require(".");
var Add = function (props) {
    var history = react_router_dom_1.useHistory();
    var link = props.link, linkBack = props.linkBack, message = props.message;
    var defaultMessage = {
        success: message && message.success
            ? message.success
            : 'New record added successfully',
        error: message && message.error
            ? message.error
            : 'An error occured while adding a new record'
    };
    var onUpdate = function (_data, y) {
        var finalLink = typeof link === 'function' ? link({ id: y || 0 }) : link;
        history.push(finalLink);
    };
    var onCancel = function (x, cancelPropagation) {
        if (cancelPropagation === void 0) { cancelPropagation = false; }
        if (cancelPropagation === true) {
            return;
        }
        typeof linkBack === 'function' ? linkBack() : history.push(linkBack);
    };
    return (react_1["default"].createElement(_1.Form, __assign({ onUpdate: onUpdate, onToggle: onCancel }, props, { message: defaultMessage })));
};
exports["default"] = Add;
